/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Trans } from "react-i18next";
import { getProfileGeneral, getFile, showModal, refreshToken } from "actions";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { withRouter, Link } from "react-router-dom";
// import requireAuth from "components/hoc/requireAuth";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";

// eslint-disable-next-line import/no-webpack-loader-syntax
import Worker from "worker-loader!../../authWorker.js";

class Profilebar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      generalProfileFetched: "init",
      file: null,
    };
    this.authWorker = new Worker();

    this.authWorker.onmessage = this.handleWorkerMessage;
  }

  handleWorkerMessage = (event) => {
    // console.log(event);
    console.log(event);
    this.props.refreshToken(
      localStorage.getItem("refreshToken"),
      this.onBegin,
      this.onRefreshSuccess,
      this.onError
    );
  };

  isOnLoginPage = () => {
    return (
      this.props.history.location.pathname.toLowerCase() === "/login" ||
      this.props.history.location.pathname.includes("/password-reset")
    );
  };

  fetchProfileGeneral = () => {
    this.props.getProfileGeneral(this.onBegin, this.onSuccess, this.onError);
  };

  componentDidMount() {
    if (!this.isOnLoginPage()) {
      this.fetchProfileGeneral();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.generalProfile.fullname &&
      this.state.file === null &&
      this.state.generalProfileFetched === "init"
    ) {
      this.fetchProfileGeneral();
    }
  }

  onBegin = () => {
    this.props.onProcessBegin();
    this.setState({ generalProfileFetched: "fetching" });
  };

  onError = (err) => {
    this.props.onProcessEnd();
    if (err.request && err.request.status === 401) {
      this.props.history.push("/login");
    }
  };

  onRefreshSuccess = () => {
    const token = localStorage.getItem("token");
    const expiration = localStorage.getItem("expiration");
    const refreshToken = localStorage.getItem("refreshToken");
    const workerObj = { type: "AUTH_PING", token, expiration, refreshToken };
    this.authWorker.postMessage(workerObj);
    this.props.onProcessEnd();
    this.fetchProfileGeneral();
  };

  onSuccess = (res) => {
    // const token = localStorage.getItem("token");
    // const expiration = localStorage.getItem("expiration");
    // const refreshToken = localStorage.getItem("refreshToken");
    // const workerObj = { type: "AUTH_PING", token, expiration, refreshToken };
    // this.authWorker.postMessage(workerObj);

    // // console.log(res);
    // this.props.onProcessEnd();

    //console.dir(res);

    if (res.imagePath) {
      this.props.getFile(
        res.imagePath,
        this.onBegin,
        this.onFileSuccess,
        this.onError,
        true
      );
    } else this.onFileSuccess(null);
  };

  onFileSuccess = (file) => {
    this.props.onProcessEnd();
    this.setState({
      generalProfileFetched: "fetched",
      file: file,
    });
  };

  renderUserImage = () => {
    const img = this.state.file
      ? this.state.file.binary
      : "/img/ford-gelisim-akademisi-avatar.svg";
    return (
      <div
        className="userImg"
        style={{
          backgroundImage: `url(${img})`,
        }}
      ></div>
    );
  };

  render() {
    // if (
    //   this.props.history.location.pathname.toLowerCase() === "/login" ||
    //   !this.props.auth.token ||
    //   this.state.generalProfileFetched !== "fetched"
    // ) {
    //   return null;
    // }

    if (this.isOnLoginPage()) return null;
    if (!this.props.generalProfile) return null;

    return (
      <>
        <a href="#">
          <div className="userArea">
            <div className="userInfoArea">
              <div className="userName">
                {this.props.generalProfile.fullname}
              </div>
              <div className="userTitle">
                {this.props.generalProfile.position}
              </div>
              <div className="userCompanyTitle">
                {this.props.generalProfile.companyName}
              </div>
            </div>
            <div
              className={`userImgArea ${this.props.generalProfile.gradeType
                ? this.props.generalProfile.gradeType.label
                : ""
                }`}
            >
              {this.props.generalProfile.gradeType ? (
                <span className="icon-icon-menu-badge"></span>
              ) : null}
              {this.renderUserImage()}
            </div>
          </div>
        </a>
        {/* <a href="#" onClick={() => this.handleWorkerMessage(10)}>
          RT
        </a> */}
        <DesktopBreakpoint>
          <ul className="userSubmenu">
            <li>
              <Link to="/profile#general">
                <span className="iconmford fo-icon-account-circle"></span>
                <span>
                  <Trans desc="Genel Bilgiler">10059</Trans>
                </span>
              </Link>
            </li>
            <li>
              <Link to="/profile#contact">
                <span className="iconmford fo-icon-perm-phone-msg"></span>
                <span>
                  <Trans desc="İletişim Bilgileri">10060</Trans>
                </span>
              </Link>
            </li>
            <li>
              <Link to="/profile#other">
                <span className="iconmford fo-icon-info"></span>
                <span>
                  <Trans desc="Diğer Bilgiler">10061</Trans>
                </span>
              </Link>
            </li>
            <li>
              <Link to="/profile#company">
                <span className="iconmford fo-icon-account-circle"></span>
                <span>
                  {/* <Trans desc="Bayi">10596</Trans> - */}
                  {this.props.generalProfile.companyName}
                </span>
              </Link>
            </li>
            {/* <li>
            <a href="#">
              <span className="icon-icon-menu-settings"></span>{" "}
              <span>Ayarlar</span>
            </a>
          </li> */}
            {/* <li>
            <a href="#">
              <span className="icon-icon-menu-password"></span>
              <span>Şifre Değiştirme</span>
            </a>
          </li> */}
            <li className="cikisButonu">
              <a href="/logout">
                <span className="iconmford fo-icon-exit-to-app"></span>{" "}
                <span>
                  <Trans desc="Çıkış">10062</Trans>
                </span>
              </a>
            </li>
          </ul>
        </DesktopBreakpoint>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    generalProfile: state.profile.general,
    modal: state.modal,
    application: state.application,
    auth: state.auth,
  };
};

export default connect(mapStateToProps, {
  getProfileGeneral,
  getFile,
  showModal,
  refreshToken,
})(withRouter(containsLongRunningProcess(Profilebar)));
